export default {
    routes: [{
        path: '/recipes',
        component: () => import('../pages/recipes/Index.vue'),
        name: 'recipes',
        meta: {
            name: 'Recipes',
            title: window.titlePrefix
        }
    }]
};